// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router","783": "lib-react",}[chunkId] || chunkId) + "." + {"116": "d82cbbbb","122": "21a578a4","235": "007adbb6","253": "a9b71ea6","354": "9c6094ad","490": "38173f60","535": "3a67d84d","634": "ee93de79","754": "54f0f530","783": "54b51dc8","940": "3fee96fb",}[chunkId] + ".js"
}